<style lang="scss" src="./index.scss"></style>
<template>
  <div :class="{ 'wgt-jn-billion': true, 'padded': true }">
    <div style="border-right: 0.5px solid #e5e5e5">
      <div class="wgt-hd-by">
        <div class="title">{{ value.byTitle }}</div>
        <div class="sub-title">{{ value.bySubtitle }}</div>
      </div>
      <div class="wgt-bd-by">
        <div class="by-card">
          <el-image :src="byList[0]?.pics[0] || defaultImg" fit="cover" />
          <div class="by-card-price">
            {{
              byList[0]?.billion_price && byList[0]?.market_price
                ? ((10 * byList[0]?.billion_price) / byList[0]?.market_price).toFixed(2)
                : 10
            }}折
          </div>
        </div>
        <div class="by-card">
          <el-image :src="byList[1]?.pics[0] || defaultImg" fit="cover" />
          <div class="by-card-price">
            {{
              byList[1]?.billion_price && byList[1]?.market_price
                ? ((10 * byList[1]?.billion_price) / byList[1]?.market_price).toFixed(2)
                : 10
            }}折
          </div>
        </div>
      </div>
    </div>
    <div style="border-left: 0.5px solid #e5e5e5">
      <div class="wgt-hd-zs">
        <div class="title">{{ value.zsTitle }}</div>
        <div class="sub-title">{{ value.zsSubtitle }}</div>
      </div>

      <div class="wgt-bd-zs">
        <div class="zs-card">
          <el-image :src="zsItem?.pics || defaultImg" fit="cover" />
        </div>
        <div class="zs-other">
          <div class="other-title">{{ zsItem?.item_name || '默认标题' }}</div>
          <div class="other-price">¥{{ zsItem?.price?.toFixed(2) || '100.0' }}</div>
          <div class="other-image-div">
            <el-image class="img-border" :src="zsItem?.send_goods?.[0]?.pics" fit="cover">
              <div slot="error" class="image-slot" />
            </el-image>
            <el-image :src="zsItem?.send_goods?.[1]?.pics" fit="cover">
              <div slot="error" class="image-slot" />
            </el-image>
            <el-image :src="zsItem?.send_goods?.[2]?.pics" fit="cover">
              <div slot="error" class="image-slot" />
            </el-image>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from './config'
const subscript = require('@/assets/img/subscript.png')

export default {
  name: 'WgtJnBillionCard',
  wgtName: '百亿模块',
  wgtDesc: '',
  wgtIcon: 'wgt-jn-billion-card',
  config: config,
  props: {
    value: [Object, Array]
  },
  data() {
    return {
      params: {
        page: 1,
        pageSize: 2,
        item_type: 'normal',
        approve_status: 'onsale',
        is_billion_flag: 1,
        category: 0,
        item_category: 0,
        is_warning: false,
        type: 0,
        distributor_id: 0,
        is_billion_buy: 1
      },
      subscriptImg: subscript,
      defaultImg: 'https://b-img-cdn.mimijishi.com/mmjs-vshop/logo.png',
      byList: [],
      zsItem: {}
    }
  },
  mounted() {
    this.$api.goods.getItemsList(this.params).then((response) => {
      this.byList = response.list
    })
    this.$api.buyandsend
      .getBuyAndSendList({ page: 1, pageSize: 1, status: 'ongoing' })
      .then((response) => {
        this.zsItem = response.list[0]
      })
  },
  methods: {}
}
</script>
